import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import {
  FeedFilterMenuItem,
  FeedFilterMenuItemStateProps,
  FeedFilterMenuItemDispatchProps,
  FeedFilterMenuItemOwnProps,
} from 'components/features/socialFeed/FeedFilters/FeedFilterMenuItem'
import { trackUIEventAction } from 'actions/analyticsActions'
import { feedSelectedFilterSelector, createFilterHasNewPostsSelector } from 'selectors/feedSelectors'
import {
  selectFeedFilterActionCreator,
  showPopupFeedFilterActionCreator,
  registerPopupFeedFilterTimeoutActionCreator,
  hidePopupFeedFilterActionCreator,
} from 'actions/feedActions'
import { currentViewportSelector } from 'selectors/viewportSelectors'
import { compareViewports } from 'helpers/viewportHelpers'

const mapStateToProps = () => {
  const hasNewPostsSelector = createFilterHasNewPostsSelector()

  return (state: State, ownProps: FeedFilterMenuItemOwnProps): FeedFilterMenuItemStateProps => {
    const viewport = currentViewportSelector(state)
    const showChevron = compareViewports(viewport, '<=', 'w768')

    return {
      selectedFilter: feedSelectedFilterSelector(state),
      shownPopupFilter: state.app.feed.filterPopup.shownFilter,
      hidePopupTimeoutId: state.app.feed.filterPopup.hideTimeoutId,
      hasNewPosts: !!hasNewPostsSelector(state, ownProps),
      showChevron,
    }
  }
}

const mapDispatchToProps: FeedFilterMenuItemDispatchProps = {
  trackUIEvent: trackUIEventAction,
  onSelectFilter: selectFeedFilterActionCreator,
  onShowPopup: showPopupFeedFilterActionCreator,
  onHidePopup: hidePopupFeedFilterActionCreator,
  onRegisterHidePopupTimeout: registerPopupFeedFilterTimeoutActionCreator,
}

export const FeedFilterMenuItemContainer = connect<
  FeedFilterMenuItemStateProps,
  FeedFilterMenuItemDispatchProps,
  FeedFilterMenuItemOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedFilterMenuItem)
